import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {HcPair} from './models/hcpair';
import {AktiviteterService} from './aktiviteter.service';
import {Tilldelningar} from './models/tilldelningar';
import {Forlaning} from './models/hc';

export interface PermanentaMedaljerModel {
    title: string;
    pair: HcPair[];
}

@Component({
    selector: 'app-permanenta-medaljer',
    template: `
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="close()">&times;</button>
                    <h4 class="modal-title">{{title || 'Confirm'}}</h4>
                </div>
                <div class="modal-body">
                    <table class="table table-bordered table-condensed table-hover" *ngIf="tilldelningar">
                        <thead>
                        <tr>
                            <th>Namn</th>
                            <th>Förkortning</th>
                            <th>Innehav</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let item of tilldelningar?.medaljer.permanenta">
                            <td><small>{{item.desc}}</small></td>
                            <td><small>{{item.short}}</small></td>
                            <td style="white-space: nowrap"><small>{{harHanDen(item)}}</small>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" (click)="close()">Stäng</button>
                </div>
            </div>
        </div>`,
    styles: []
})
export class PermanentaMedaljerComponent extends DialogComponent<PermanentaMedaljerModel, boolean>
    implements PermanentaMedaljerModel, OnInit {
    title: string;
    pair: HcPair[];
    tilldelningar: Tilldelningar;

    constructor(dialogService: DialogService, private aktiviteterService: AktiviteterService) {
        super(dialogService);
    }

    ngOnInit(): void {
        this.aktiviteterService.getTilldelningar().then(result => this.tilldelningar = result);
    }

    harHanDen(medalj: Forlaning): string {
        for (const p of this.pair) {
            if (p.shortname === medalj.short) {
                return p.date ? p.date : 'Habet';
            }
        }
        return '--';
    }

}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/permanenta.component.ts